import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class IstekSikayetGetAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "IstekSikayetGet";
    super(baseUrl);
  }


  getIstekSikayetGetListe(  BasvuruNo?: number){
    var request= new IstekSikayetGetRequest( BasvuruNo);
    return this.post("",request, false);
  }

}
export default new IstekSikayetGetAPI();
class IstekSikayetGetRequest {
  public BasvuruNo?: number; 

  constructor( BasvuruNo?: number) {
   
    this.BasvuruNo = BasvuruNo;
  }
}
export { IstekSikayetGetRequest };